import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Link, Navigate } from 'react-router-dom';
import './App.css';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import CDRList from './components/CDRList';
import Customers from './components/Customers';
import RateCards from './components/RateCards';
import Providers from './components/Providers';
import { useInactivityTimer } from './hooks/useInactivityTimer';

function App() {
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('user') || '{}'));
  const [sessionExpired, setSessionExpired] = useState(false);

  useEffect(() => {
    // Check if session expired
    try {
      const expired = localStorage.getItem('sessionExpired');
      if (expired === 'true') {
        setSessionExpired(true);
        localStorage.removeItem('sessionExpired');
      }
    } catch (e) {
      console.error('localStorage not available:', e);
    }
  }, []);

  const handleLogin = (newToken, userData) => {
    setToken(newToken);
    setUser(userData);
    localStorage.setItem('token', newToken);
    localStorage.setItem('user', JSON.stringify(userData));
    localStorage.removeItem('sessionExpired');
    setSessionExpired(false);
  };

  const handleLogout = () => {
    setToken(null);
    setUser({});
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  };

  // Use inactivity timer hook when user is logged in
  useInactivityTimer(token ? handleLogout : null);

  if (!token) {
    return <Login onLogin={handleLogin} sessionExpired={sessionExpired} />;
  }

  return (
    <Router>
      <div className="app">
        <div className="sidebar">
          <div className="sidebar-header">
            <div className="logo-circle-small">LBS</div>
            <h2>Legend Billing</h2>
            <p className="user-email">{user.email}</p>
            <span className="user-role">{user.role?.toUpperCase()}</span>
          </div>
          
          <nav className="nav-menu">
            <Link to="/dashboard">Dashboard</Link>
            <Link to="/cdrs">Call Records</Link>
            {user.role === 'admin' && (
              <>
                <Link to="/customers">Customers</Link>
                <Link to="/rates">Rate Cards</Link>
                <Link to="/providers">Providers</Link>
              </>
            )}
          </nav>
          
          <button onClick={handleLogout} className="btn-logout">Logout</button>
        </div>

        <div className="main-content">
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard" />} />
            <Route path="/dashboard" element={<Dashboard user={user} />} />
            <Route path="/cdrs" element={<CDRList />} />
            {user.role === 'admin' && (
              <>
                <Route path="/customers" element={<Customers />} />
                <Route path="/rates" element={<RateCards />} />
                <Route path="/providers" element={<Providers />} />
              </>
            )}
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
